import React from 'react';
import './Skills.css';
import { portfolioData } from '../data/portfolioData';

const Skills: React.FC = () => {
  const { skills } = portfolioData;

  // Helper function to handle spaces in animated text
  const AnimatedText = ({ text }: { text: string }) => (
    <div className="skill-name">
      {text.split('').map((char, i) => (
        <span 
          key={i} 
          className={char === ' ' ? 'letter space' : 'letter'}
          style={{ animationDelay: `${i * 0.1}s` }}
        >
          {char === ' ' ? '\u00A0' : char}
        </span>
      ))}
    </div>
  );

  return (
    <div className="skills-container">
      <h1 className="skills-title">Skills & Expertise</h1>

      <div className="category-section technical-section">
        <h2 className="category-title">Core Technical Skills</h2>
        <div className="skills-grid">
          {skills.technical.map((skill, index) => (
            <div 
              key={index} 
              className="skill-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="skill-logo">
                <img
                  src={skill.logo}
                  alt={`${skill.name} logo`}
                  className="logo-image"
                />
              </div>
              <div className="skill-content">
                <AnimatedText text={skill.name} />
                <div className="skill-description">{skill.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="category-section domain-section">
        <h2 className="category-title">Domain Expertise</h2>
        <div className="skills-grid">
          {skills.domain.map((skill, index) => (
            <div 
              key={index} 
              className="skill-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="skill-logo">
                <img
                  src={skill.logo}
                  alt={`${skill.name} logo`}
                  className="logo-image"
                />
              </div>
              <div className="skill-content">
                <AnimatedText text={skill.name} />
                <div className="skill-description">{skill.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="category-section tools-section">
        <h2 className="category-title">Professional Tools</h2>
        <div className="skills-grid">
          {skills.tools.map((tool, index) => (
            <div 
              key={index} 
              className="skill-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="skill-logo">
                <img
                  src={tool.logo}
                  alt={`${tool.name} logo`}
                  className="logo-image"
                />
              </div>
              <div className="skill-content">
                <AnimatedText text={tool.name} />
                <div className="skill-description">{tool.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="category-section qualifications-section">
        <h2 className="category-title">Professional Qualifications</h2>
        <div className="skills-grid">
          {skills.qualifications.map((qual, index) => (
            <div 
              key={index} 
              className="skill-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="skill-logo">
                <img
                  src={qual.logo}
                  alt={`${qual.name} logo`}
                  className="logo-image"
                />
              </div>
              <div className="skill-content">
                <AnimatedText text={qual.name} />
                <div className="skill-description">{qual.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="category-section soft-skills-section">
        <h2 className="category-title">Soft Skills</h2>
        <div className="skills-grid">
          {skills.softSkills.map((skill, index) => (
            <div 
              key={index} 
              className="skill-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="skill-logo">
                <img
                  src={skill.logo}
                  alt={`${skill.name} logo`}
                  className="logo-image"
                />
              </div>
              <div className="skill-content">
                <AnimatedText text={skill.name} />
                <div className="skill-description">{skill.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;
